import angular from 'angular';
import _ from 'lodash-es';
import $ from 'jquery';
import { replaceBulk } from '~/utils/string';
import kformUtils from '../../utils/kform-utils';
import template from './datetime.html';
import './datetime.scss';

// dd/MM/yyyy => d/m/Y
const convertFormat = (/** @type {any} */ format) => replaceBulk(
	format,
	// eslint-disable-next-line no-multi-spaces
	['dd', 'MM', 'yyyy', 'HH', 'mm', 'ss'],
	// eslint-disable-next-line no-multi-spaces
	['d',  'm',  'Y',    'H',  'i',  's'],
);

const datetimeConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('datetime', {
		title:      'Date / Time',
		template,
		/**
		 * @param {string | Date} data
		 * @param {any} options
		 * @returns {string}
		 */
		tableView(data, options) {
			// eslint-disable-next-line no-param-reassign
			data = _.isDate(data) ? data.toISOString() : data;
			return options.$interpolate(`<span>{{ "${data}" | date: "${options.component.format}" }}</span>`)();
		},
		group:      'advanced',
		onEdit:     /* @ngInject */ (/** @type {any} */ $scope) => {
			// FOR-34 - Update 12hr time display in the field, not only time picker.
			$scope.$watch('component.timePicker.showMeridian', (/** @type {any} */ value) => {
				const oldValue = value ? 'HH' : 'hh';
				const newValue = value ? 'hh' : 'HH';

				if ($scope.component.enableTime) {
					$scope.component.format = $scope.component.format.toString().replace(oldValue, newValue);
				}
			});

			$scope.setFormat = () => {
				let stdFormatDateTime = 'yyyy-MM-dd HH:mm';
				const stdFormatDate = 'yyyy-MM-dd';
				let stdFormatTime = 'HH:mm';
				if ($scope.component.timePicker.showMeridian) {
					stdFormatDateTime = 'yyyy-MM-dd hh:mm';
					stdFormatTime = 'hh:mm';
				}
				const stdFormats = new Set([
					stdFormatDateTime,
					stdFormatDate,
					stdFormatTime,
				]);

				if (
					$scope.component.enableDate
					&& $scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatDateTime;
				}
				else if (
					$scope.component.enableDate
					&& !$scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatDate;
				}
				else if (
					!$scope.component.enableDate
					&& $scope.component.enableTime
					&& stdFormats.has($scope.component.format)
				) {
					$scope.component.format = stdFormatTime;
				}
			};
			$scope.startingDays = [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
			];
			$scope.modes = [
				{
					name:  'day',
					label: 'Day',
				},
				{
					name:  'month',
					label: 'Month',
				},
				{
					name:  'year',
					label: 'Year',
				},
			];
		},
		icon:          'fa fa-calendar-plus-o',
		views:        [
			{
				name:     'Display',
				template: 'kform/components/datetime/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/datetime/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/datetime/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},

		],
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
		) => {
			// Watch for changes to the meridian settings to synchronize the submissionGrid and component view.
			// $scope.$watch('component.timePicker.showMeridian', update => {
			// 	// Remove any meridian reference, because were not in 12 hr.
			// 	if (!$scope.component.enableTime || !update) {
			// 		$scope.component.format = $scope.component.format.replace(/ a/, '');
			// 		return;
			// 	}
			//
			// 	// If we're missing the meridian string and were in 12 hr, add it.
			// 	if (update && !$scope.component.format.includes(' a')) {
			// 		$scope.component.format += ' a';
			// 	}
			// });

			// $scope.$watch('component.datePicker.showWeeks', showWeekds => {
			// 	$scope.fpOptions.weekNumbers = showWeekds;
			// });
			//
			// $scope.$watch('component.datePicker.startingDay', startingDay => {
			// 	$scope.fpOptions.startingDay = startingDay;
			// });

			$scope.component.datePicker.minDate = kformUtils.getDateSetting(_.get($scope.component, 'datePicker.minDate'));
			$scope.component.datePicker.maxDate = kformUtils.getDateSetting(_.get($scope.component, 'datePicker.maxDate'));

			$scope.autoOpen = true;
			$scope.onClosed = () => {
				$scope.autoOpen = false;
				$timeout(() => {
					$scope.autoOpen = true;
				}, 250);
			};

			$scope.changeValue = () => {
				// trigger change event
				$(`#${$scope.component.key}`).trigger('change');
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};

			$scope.fpOptions = {
				allowInfinity: $scope.component.allowInfinity,
				allowInput:    true,
				allowSetNow:   true,
				altFormat:     convertFormat($scope.component.format),
				closeOnScroll: true,
				displayInput:  true,
				enableTime:    $scope.component.enableTime,
				defaultDate:   $scope.component.defaultDate,
				placeholder:   $scope.component.placeholder,
				time_24hr:     !$scope.component.timePicker.showMeridian,
				weekNumbers:   $scope.component.showWeeks,
			};
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus:      false,
			input:          true,
			tableView:      true,
			label:          'Date Time',
			key:            'datetime',
			placeholder:    '',
			format:         'yyyy-MM-dd HH:mm a',
			hideLabel:      false,
			enableDate:     true,
			enableTime:     true,
			defaultDate:    '',
			disabled:       false,
			datepickerMode: 'day',
			datePicker:     {
				showWeeks:   true,
				initDate:    '',
				minMode:     'day',
				maxMode:     'year',
				yearRows:    4,
				yearColumns: 5,
				minDate:     null,
				maxDate:     null,
			},
			timePicker:     {
				hourStep:      1,
				minuteStep:    1,
				showMeridian:  false,
				readonlyInput: false,
				mousewheel:    true,
				arrowkeys:     true,
			},
			protected:      false,
			persistent:     true,
			hidden:         false,
			clearOnHide:    true,
			allowInfinity:  false,
			validate:       {
				card:   '0-1',
				custom: '',
			},
			event:          {
				onChange: null,
			},
			kdata:          {
				submit: true,
			},
		},
	});
};

export default angular.module('app').config(datetimeConfig);
